export default __webpack_public_path__ + "befc5cacce9dda95bad6d27e9bc8c853.svg";